import { fetcher } from '@commenda/utils';

export const deleteServiceAlert = async (id: string) => {
  const response = await fetcher(`service-alerts/${id}`, {
    method: 'DELETE',
  });

  return response;
};
